<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="d-flex gp-8">
        <div>
          <div class="label-base pb-1">Prefijo</div>
          <v-select
            v-model="countryCode"
            :items="countryCodes"
            dense
            solo
            hide-details="auto"
            item-text="text"
            item-value="value"
            class="input-base  max-w-130"
            append-icon="$caretDownFormIcon"
          >
            <template v-slot:selection="data">
              <span class="d-inline-block text-truncate"> {{ data.item.flag }} {{ data.item.value }}</span>
            </template>
          </v-select>
        </div>
        <div class="flex-grow-1">
          <div class="label-base pb-1">Celular</div>
          <v-text-field
            v-model="localNumber"
            type="number"
            dense
            solo
            hide-details
            class="input-base no-spinner"
            @keydown="blockE"
            @input="updatePhone"
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      countryCode: "+1",
      localNumber: "",
      countryCodes: [
        { flag: "🇺🇸", text: "🇺🇸 +1 (USA)", value: "+1" },
        { flag: "🇨🇦", text: "🇨🇦 +1 (Canada)", value: "+1" },
        { flag: "🇲🇽", text: "🇲🇽 +52 (Mexico)", value: "+52" },
        { flag: "🇧🇷", text: "🇧🇷 +55 (Brazil)", value: "+55" },
        { flag: "🇦🇷", text: "🇦🇷 +54 (Argentina)", value: "+54" },
        { flag: "🇨🇴", text: "🇨🇴 +57 (Colombia)", value: "+57" },
        { flag: "🇧🇴", text: "🇧🇴 +591 (Bolivia)", value: "+591" },
        { flag: "🇨🇱", text: "🇨🇱 +56 (Chile)", value: "+56" },
        { flag: "🇵🇪", text: "🇵🇪 +51 (Peru)", value: "+51" },
        { flag: "🇪🇨", text: "🇪🇨 +593 (Ecuador)", value: "+593" },
        { flag: "🇻🇪", text: "🇻🇪 +58 (Venezuela)", value: "+58" },
        { flag: "🇬🇧", text: "🇬🇧 +44 (UK)", value: "+44" },
        { flag: "🇩🇪", text: "🇩🇪 +49 (Germany)", value: "+49" },
        { flag: "🇫🇷", text: "🇫🇷 +33 (France)", value: "+33" },
        { flag: "🇪🇸", text: "🇪🇸 +34 (Spain)", value: "+34" },
        { flag: "🇮🇹", text: "🇮🇹 +39 (Italy)", value: "+39" },
        { flag: "🇳🇱", text: "🇳🇱 +31 (Netherlands)", value: "+31" },
        { flag: "🇸🇪", text: "🇸🇪 +46 (Sweden)", value: "+46" },
        { flag: "🇳🇴", text: "🇳🇴 +47 (Norway)", value: "+47" },
        { flag: "🇩🇰", text: "🇩🇰 +45 (Denmark)", value: "+45" },
        { flag: "🇯🇵", text: "🇯🇵 +81 (Japan)", value: "+81" },
        { flag: "🇨🇳", text: "🇨🇳 +86 (China)", value: "+86" },
        { flag: "🇮🇳", text: "🇮🇳 +91 (India)", value: "+91" },
        { flag: "🇰🇷", text: "🇰🇷 +82 (South Korea)", value: "+82" },
        { flag: "🇦🇺", text: "🇦🇺 +61 (Australia)", value: "+61" },
        { flag: "🇳🇿", text: "🇳🇿 +64 (New Zealand)", value: "+64" },
        { flag: "🇿🇦", text: "🇿🇦 +27 (South Africa)", value: "+27" },
        { flag: "🇷🇺", text: "🇷🇺 +7 (Russia)", value: "+7" },
        { flag: "🇸🇬", text: "🇸🇬 +65 (Singapore)", value: "+65" },
        { flag: "🇲🇾", text: "🇲🇾 +60 (Malaysia)", value: "+60" },
        { flag: "🇹🇭", text: "🇹🇭 +66 (Thailand)", value: "+66" },
        { flag: "🇵🇭", text: "🇵🇭 +63 (Philippines)", value: "+63" },
        { flag: "🇮🇩", text: "🇮🇩 +62 (Indonesia)", value: "+62" },
        { flag: "🇦🇪", text: "🇦🇪 +971 (UAE)", value: "+971" },
        { flag: "🇸🇦", text: "🇸🇦 +966 (Saudi Arabia)", value: "+966" },
        { flag: "🇹🇷", text: "🇹🇷 +90 (Turkey)", value: "+90" },
        { flag: "🇪🇬", text: "🇪🇬 +20 (Egypt)", value: "+20" },
      ],
    };
  },
  mounted() {
    this.setFromValue(this.value);
  },
  watch: {
    value(newVal) {
      console.log("newVal :", newVal);
      if (newVal !== this.countryCode + this.localNumber) {
        this.setFromValue(newVal);
      }
    },
    countryCode() {
      this.emitValue();
    },
    localNumber() {
      this.emitValue();
    },
  },
  methods: {
    blockE(e) {
      const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
        if (!allowedKeys.includes(e.key) && (e.key < "0" || e.key > "9")) {
          e.preventDefault();
        }
    },
    setFromValue(val) {
      if (!val) {
        this.countryCode = "+1";
        this.localNumber = "";
        return;
      }
      const code = this.countryCodes.find((c) => val.startsWith(c.value));
      if (code) {
        this.countryCode = code.value;
        this.localNumber = val.slice(code.value.length);
      } else {
        this.countryCode = "+1";
        this.localNumber = val;
      }
    },
    updatePhone() {
      this.emitValue();
    },
    emitValue() {
      this.$emit("input", this.countryCode + this.localNumber);
    },
  },
};
</script>
